import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Navigation.css';

function Navigation() {
  return (
    <Navbar bg='dark' variant='dark' expand='lg'>
      <Navbar.Brand><div className='format'>Marques Traylor`s Portfolio</div></Navbar.Brand>
      <Nav>
        <Nav.Item>
          <Nav.Link href='https://github.com/TraylorBoy' target='_blank'>Github</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link href='https://www.linkedin.com/in/traylorboy/' target='_blank'>LinkedIn</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link href='https://dev.to/traylorboy' target='_blank'>Dev</Nav.Link>
        </Nav.Item>
      </Nav>
    </Navbar>
  );
}

export default Navigation;
